import type { TourDealsGetResponse } from 'api/tour/tourV2'
import { TOUR_DEFAULT_DEAL_HERO_IMAGE_ID, TOUR_DEFAULT_DEAL_HIGHLIGHT_COLOUR } from 'constants/tours'

const defaultHeroImageKey = TOUR_DEFAULT_DEAL_HERO_IMAGE_ID
const defaultHighlightColour = TOUR_DEFAULT_DEAL_HIGHLIGHT_COLOUR

export function dealMapper(deal: TourDealsGetResponse['result'][number]): App.Tours.TourDeal {
  return {
    heading: deal.heading,
    subHeading: deal.subheading,
    dealType: deal.dealType,
    heroImageId: deal.heroImageKey ?? defaultHeroImageKey,
    highlightColour: deal.colourHex ?? defaultHighlightColour,
    endDate: deal.endAt ?? '',
  }
}

export function dealDetailsMapper(deal: TourDealsGetResponse['result'][number]): App.Tours.TourDealDetails {
  return {
    ...dealMapper(deal),
    tours: deal.tours.map((tour) => ({
      id: tour.id,
      brand: tour.brand,
      tourStyle: tour.tourStyle,
      countriesVisited: tour.countriesVisited,
      memberPrices: tour.memberPrices ?? false,
      memberEarlyAccess: tour.memberEarlyAccess ?? false,
      price: tour.price,
      duration: tour.duration,
    })),
    facets: dealFacetsMapper(deal),
  }
}

export function dealsMapper(deals: TourDealsGetResponse['result']): Record<string, App.Tours.TourDeal> {
  return deals.reduce((acc, deal) => {
    acc[deal.slug] = dealMapper(deal)
    return acc
  }, {} as Record<string, App.Tours.TourDeal>)
}

export function dealFacetsMapper(deal: TourDealsGetResponse['result'][number]): App.Tours.TourDealFacets {
  return {
    operators: deal.facets?.brand ?? [],
    countries: deal.facets?.countriesVisited ?? [],
    categories: deal.facets?.categories ?? [],
    tourStyles: deal.facets?.tourStyle ?? [],
    luxPlusFeatures: deal.facets?.luxPlus ?? [],
    duration: {
      min: deal.facets?.duration?.min ?? 0,
      max: deal.facets?.duration?.max ?? 0,
    },
    price: {
      min: deal.facets?.price?.min ?? 0,
      max: deal.facets?.price?.max ?? 0,
    },
  }
}
